import generateDeck from './scripts/generateDeck';
import render from './scripts/render';
import jitter from './scripts/jitter';
import Loader from './scripts/loader';

/* VARIABLES */
// tarot configuration name
const cfg = 'tarot-config';

// start the loader
Loader.create();

/* For testing purpose only to display the error message */
//if (!window.MaestroInstance2) {
if (!window.MaestroInstance) {
    Loader.noMaestroError();
} else {
    /* use maestro to load module configuration */
    window.MaestroInstance.Store.loadAsync(cfg).then((e) => {
        console.time('render_time');
        console.log('standalone tarot', e);
        if (Object.keys(e).length) mountApp(e);

        //for testing purposes only - add a timeout to get the loader visible on local testing

        /*setTimeout(() => {
            Loader.hide();
        }, 10000);*/

        //hide the loader
        Loader.hide();
    });
}

function mountApp(e) {
    /* Initialize data for the app - used as default or for local testing*/
    const data = {
        deck: generateDeck(e.originalDeck, e.totalCards, true),
        back: {
            source: e.backCardImage,
        },
        frame: null,
        title: {
            start: e.openingText,
            end: e.resultText,
        },
        config: {
            module: 'tarot',
            amount: e.pickCards,
            duration: 400,
            shape: e.cardDisposition,
            animation: e.animation,
            css: {
                'overlap-cards': typeof e.overlap === 'undefined' ? true : e.overlap,
                'disable-animation': !e.animation,
                'enable-hover': true,
            },
        },
        state: {
            selected: [],
            disabled: false,
        },
        stop: function () {
            this.state.disabled = true;
        },
        start: function () {
            this.state.disabled = false;
        },
        log: function () {
            console.log(this.state);
        },
        jitter: function () {
            this.config.animation = false;
            return jitter(5, 4);
        },
        result: function () {
            return data.deck[this.state.selected[this.state.selected.length - 1]];
        },
    };

    if (data.config.shape == 'pile') data.config.pile = data.jitter();

    render(data);
    console.log('render-data', data);
}
